import request from '@/utils/request'

/**
 * 图片上传
 *
 * @export
 * @param file 图片
 * @param {string} dir 目录名称 例：Album 或 Album/Scenery
 * @returns
 */
export function uploadImg(file, dir = 'Pictures') {
  const formData = new FormData()
  formData.append('image', file)
  return request({
    url: `/Api/Comm/UploadImg?dir=${dir}`,
    method: 'POST',
    data: formData
  })
}

/**
 * 生成图片
 *
 * @export
 * @param {string} base64 内容
 * @param {string} name 文件名称 xxx.png
 * @returns
 */
export function createImg(base64, name) {
  return request({
    url: '/Api/Comm/CreateImg',
    method: 'POST',
    data: { name, base64 }
  })
}

/**
 * 单页内容
 *
 * @export
 * @param {string} code Info 网站介绍|Appointment 服务公约|Service 服务条款|Register 注册协议|Market 推广管理|
 Alliance 加盟商佣金规则|SalesMan 业务员佣金规则|Customer 消费者佣金规则|Sacrificial 祭祀服务内容
 * @returns
 */
export function getSinglepage(code) {
  return request({
    url: `/Api/Comm/Singlepage?code=${code}`,
    method: 'GET'
  })
}

/**
 * 微信页面分享
 *
 * @export
 * @returns
 * @param data
 */
export function sharePage(data) {
  return request({
    url: `/Api/Comm/SharePage?url=${data.url}&title=${data.title}&desc=${data.desc}&imgUrl=${data.imgUrl}`,
    method: 'POST'
  })
}
